import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import SpreadPartial from '../spread-partial';

class Component extends BaseComponent {
    render({ type }) {
        const Spread = `${type}-spread`;
        return (
            <Spread>
                {this.renderSpreadRow()}
            </Spread>
        );
    }

    renderSpreadRow = () => {
        let start_index = 0;
        let rows = [];

        this.props.row_breakpoints.map(index => {
            rows.push(
                <SpreadPartial positions={
                    this.props.positions.slice(start_index, index).map(
                        (p, i) => ({ ...p, card_index: i + start_index })
                    )
                }
                />
            );
            start_index = index;
        });

        return (rows);
    }
}

const mapStateToProps = (state) => ({
    positions: state.product && state.product.teeup && state.product.teeup.fields
        && state.product.teeup.fields[2] && state.product.teeup.fields[2].positions,
});

export default connect(mapStateToProps)(Component);
